import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdminLayout from '../components/AdminLayout.jsx';
import { api, uploadUrl } from '../../api/client.js';
import { Swal2 } from '../../lib/swal.js';
import { MORPH_BTN } from '../../lib/ui.js';

const empty = { title: '', subtitle: '', button_text: '', button_url: '', sort_order: 0, is_active: true };

export default function CarouselForm() {
  const { id } = useParams();
  const isEdit = !!id;
  const navigate = useNavigate();
  const [form, setForm] = useState(empty);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isEdit) {
      api.get(`/admin/carousel/${id}`).then(({ data }) => {
        setForm({ ...data.item, is_active: !!data.item.is_active });
        setPreview(data.item.image ? uploadUrl(data.item.image) : '');
      });
    }
  }, [id]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onFile = (e) => {
    const f = e.target.files[0];
    setFile(f);
    if (f) setPreview(URL.createObjectURL(f));
  };

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => { if (k !== 'image' && k !== 'id') fd.append(k, v); });
      if (file) fd.append('image', file);

      if (isEdit) await api.put(`/admin/carousel/${id}`, fd);
      else await api.post('/admin/carousel', fd);
      Swal2.toast('success', isEdit ? 'Berhasil diperbarui.' : 'Berhasil ditambahkan.');
      navigate('/admin/carousel');
    } catch (err) {
      setError(err.response?.data?.message || 'Gagal menyimpan.');
    } finally {
      setSaving(false);
    }
  };

  const inputCls = 'w-full px-4 py-3 rounded-xl border text-sm outline-none bg-neutral-50 dark:bg-neutral-800 dark:text-white border-neutral-200 dark:border-neutral-700 focus:border-forest-500 focus:ring-2 focus:ring-forest-500/20';
  const labelCls = 'block text-xs font-bold text-neutral-500 uppercase tracking-wider mb-1.5';

  return (
    <AdminLayout title={isEdit ? 'Edit Slide' : 'Tambah Slide Baru'}>
      <form onSubmit={submit} className="max-w-2xl bg-white dark:bg-neutral-900 rounded-2xl border border-black/5 dark:border-white/5 p-6 space-y-4">
        {error && <div className="p-3 rounded-xl text-sm font-semibold bg-red-50 text-red-600 dark:bg-red-950/30">{error}</div>}

        <div>
          <label className={labelCls}>Judul</label>
          <input required className={inputCls} value={form.title} onChange={set('title')} />
        </div>
        <div>
          <label className={labelCls}>Subjudul</label>
          <textarea rows={2} className={`${inputCls} resize-none`} value={form.subtitle || ''} onChange={set('subtitle')} />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className={labelCls}>Teks Tombol</label>
            <input className={inputCls} value={form.button_text || ''} onChange={set('button_text')} />
          </div>
          <div>
            <label className={labelCls}>Link Tombol</label>
            <input className={inputCls} placeholder="/kontak atau #layanan" value={form.button_url || ''} onChange={set('button_url')} />
          </div>
        </div>
        <div>
          <label className={labelCls}>Gambar Latar</label>
          {preview && <img src={preview} className="w-full h-40 object-cover rounded-xl mb-2" />}
          <input type="file" accept="image/*" onChange={onFile} className="text-sm text-neutral-500" />
        </div>
        <div className="grid grid-cols-2 gap-4 items-center">
          <div>
            <label className={labelCls}>Urutan</label>
            <input type="number" className={inputCls} value={form.sort_order} onChange={set('sort_order')} />
          </div>
          <label className="flex items-center gap-2 mt-6 text-sm font-semibold text-neutral-700 dark:text-white">
            <input type="checkbox" checked={form.is_active} onChange={(e) => setForm((f) => ({ ...f, is_active: e.target.checked }))} className="w-4 h-4 accent-forest-500" />
            Tampilkan slide ini
          </label>
        </div>

        <div className="flex gap-3 pt-2">
          <button disabled={saving} type="submit" className={`px-6 py-3 rounded-xl font-bold text-white text-sm ${MORPH_BTN}`} style={{ background: 'var(--accent)' }}>{saving ? 'Menyimpan...' : 'Simpan'}</button>
          <button type="button" onClick={() => navigate('/admin/carousel')} className={`px-6 py-3 rounded-xl font-bold text-sm bg-neutral-100 dark:bg-neutral-800 text-neutral-600 dark:text-white ${MORPH_BTN}`}>Batal</button>
        </div>
      </form>
    </AdminLayout>
  );
}
